import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { Field } from "formik";
import { FormGroup, Label } from "reactstrap";
import selectOptions from "shared/prop_types/selectOptions";
import { RadioButton } from "shared/formik/formik_helpers";

const FormRadioGroup = ({ name, options, className, isDisabled }) => (
  <FormGroup
    check
    className={classNames("custom-control custom-radio", className)}
  >
    {options.map(({ value, label }) => {
      const key = `${name}-${value}`;
      return (
        <Field key={key} name={name}>
          {({ field, form }) => (
            <FormGroup>
              <RadioButton
                key={key}
                id={key}
                name={name}
                value={value}
                field={field}
                form={form}
                disabled={!!isDisabled(form.values)}
                className="custom-control-input"
              />
              <Label check className="custom-control-label" htmlFor={key}>
                {label}
              </Label>
            </FormGroup>
          )}
        </Field>
      );
    })}
  </FormGroup>
);

FormRadioGroup.propTypes = {
  /** the name of the Formik Field that represents this Radio Group */
  name: PropTypes.string.isRequired,
  /** the options that define the Radio Inputs for this Radio Group */
  options: selectOptions,
  /** determines if the Radio inputs should be disabled */
  isDisabled: PropTypes.func,
  /** a class to provide to the overall Radio Group */
  className: PropTypes.string
};

FormRadioGroup.defaultProps = {
  isDisabled: () => {}
};

export default FormRadioGroup;
